// extracted by mini-css-extract-plugin
export default {"statModal":"P_L47pMHoqplEZY0TzPO","modalHeader":"IVbnu0FTK7_0LgVyaViD"};